import { checkAndFetchAuth } from '~/utils/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
    // Check authentication and try to fetch if needed
    const hasAuthCookies = await checkAndFetchAuth();

    let isAuthenticated = false;

    if (hasAuthCookies) {
        // check that access token is valid
        try {
            const config = useRuntimeConfig();
            const auat = useCookie('auat');
            const response = await $fetch(`${config.public.apiUrl}/auth-check`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${auat.value}`,
                    'Accept': 'application/json'
                }
            });

            isAuthenticated = response === 'ok';

            // If auth check failed, clear cookies
            if (!isAuthenticated) {
                const arst = useCookie('arst');
                const auat = useCookie('auat');
                const uid = useCookie('uid');

                arst.value = null;
                auat.value = null;
                uid.value = null;
            }
        } catch (error) {
            console.error('Auth check failed:', error);
            isAuthenticated = false;

            // Clear invalid cookies to prevent redirect loop
            const arst = useCookie('arst');
            const auat = useCookie('auat');
            const uid = useCookie('uid');

            arst.value = null;
            auat.value = null;
            uid.value = null;
        }
    }

    if (!hasAuthCookies || !isAuthenticated) {
        // Save intended URL in cookie for later redirect
        const intendedUrl = useCookie('intended_url', {
            maxAge: 60 * 10, // 10 minutes
            secure: true,
            sameSite: 'lax'
        });
        intendedUrl.value = to.fullPath;

        // Redirect to login page with callback URL
        const config = useRuntimeConfig();
        const callbackUrl = config.public.appUrl + '/auth/callback';
        const loginUrl = config.public.boardDomain + '/set-app-auth?redirect=' + encodeURIComponent(callbackUrl);
        return navigateTo(loginUrl, { external: true });
    }
});
